module.exports = __webpack_public_path__ + "static/logo-29c68fc7202beda7b9e757091929f465.png";